import React, { useState } from 'react';
import ContactMailParams from '../types/ContactMailParams';
import contactMail from '../api/contactMail';

const ContactMailMain: React.FC = () => {
  const [email, setEmail] = useState<string>("")
  const [alertMessageOpen, setAlertMessageOpen] = useState<boolean>(false)
  const [alertMessages, setAlertMessages] = useState<string[]>([])
  const [isSubmitted, setSubmitted] = useState<boolean>(false)

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const params: ContactMailParams = {
      email: email
    }

    try {
      await contactMail(params);
      setAlertMessageOpen(false);
      setSubmitted(true);
    } catch (err: any) {
      setAlertMessageOpen(true);
      // err.responseが存在し、かつerr.response.dataが存在する場合
      if (err.response && err.response.data && err.response.data.errors) {
        setAlertMessageOpen(true);
        setAlertMessages(err.response.data.errors);
      } else {
        // 予期せぬエラーの場合の処理
        setAlertMessageOpen(false);
        console.log('An unexpected error occurred:', err);
      }
    }
  }

  const messages = alertMessages.length === 0 ? '' : alertMessages.map((message: string) =>
    <li>{message}</li>
  );

  const form = (
    <div className="inner">
      <div className="sec-contact__item">
        <h1 className="c-ttl__01">お問い合わせ</h1>
        { alertMessageOpen &&
          <div className="contact-note mbpc-26 mbsp-24">
            <ul>{ messages }</ul>
          </div>
        }
        <div className="contact-box">
          <div className="contact-box__left">
            <form onSubmit={handleSubmit}>
              <div className="contact-box__form" id="id-01">
                <h2 className="c-ttl__02 mbsp-13">シード オルソケラトロジー事業推進部</h2>
                <p className="c-txt__01 contact-box__txt"> お問い合わせ電話番号：03-3813-1116<br /> 受付時間： 平日10:00～17:00<br /> メールにてお問い合わせの方は下記の項目をご入力の上、「認証メールを送信」ボタンを押してください。 </p>
                <div className="contact-box__item">
                  <label className="contact-box__ttl">
                    <span>メールアドレス</span>
                    <small>必須</small>
                  </label>
                  <div className="contact-box__ct">
                    <input name="email" type="text" className="input" onChange={ event => setEmail(event.target.value) } />
                  </div>
                </div>
              </div>
              <button type="submit" className="c-btn__01">認証メールを送信</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );

  const completed = (
    <div className="inner">
      <h1 className="c-ttl__01">お問い合わせ認証メール送信完了</h1>
      <p className="c-txt__01"><span>お客様の登録メールアドレスに<br />お問い合わせの認証アドレスを送信致しました。</span></p>
    </div>
  );

  return (
    <React.Fragment>
      <main id="page-lens_order" className="wrapper">
        <section className="sec-contact">
          { isSubmitted ? completed : form }
        </section>
      </main>
    </React.Fragment>
  );
}

export default ContactMailMain;
